import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTaskContext } from '../context/TaskContext';
import { useUserContext } from '../context/UserContext';
import { useStatusContext } from '../context/StatusContext';
import { useContractorsContext } from '../context/ContractorsContext';
import { useEffect } from 'react';
import { useRolesContext } from '../context/RolesContext';
import ExecutorSelect from './ExecutorSelect';

const ModalWindow = ({ task, onClose }) => {
  const {addTask, updateTask, deleteTask, deleteFile} = useTaskContext();
  const {users, id, roleId} = useUserContext();
  const { roles } = useRolesContext();
  const {status} = useStatusContext();
  const {contractors} = useContractorsContext();
  const [name, setName] = useState(task?task.name:'');
  const [description, setDescription] = useState(task?task.description:'');
  // const [executor, setExecutor] = useState(task?task.executor:id);
  const [executors, setExecutors] = useState(() => {
    if (!task) return id ? [id] : [];
    if (Array.isArray(task.executors)) return task.executors;
    if (typeof task.executor === 'string' && task.executor) return [task.executor]; // миграция старых записей
    return id ? [id] : [];
  });
  const [finishDate, setFinishDate] = useState(task?.finishDate ? new Date(task.finishDate).toISOString().slice(0,16) : '');
  const [stat, setStat] = useState(task?.status || status?.[0]?._id || '');
  const [creator, setCreator] = useState(task?task.creator:id);
  const [comment, setComment] = useState('');
  const [contractor, setContractor] = useState(task?task.contractor:"")
  const [roleType, setRoleType] = useState(null)
  const isCreator = !!task && String(task.creator) === String(id);
  const canEditCore = !task || isCreator;      // создание разрешено всем; редактирование ядра — только автору
  const [files, setFiles] = useState([])

useEffect(()=>{
          if (roles){
            let idx = roles.findIndex((r)=>{return r._id===roleId});
            if (idx !== -1){
              setRoleType(roles[idx].type)
            }
          }
        }, [roles, roleId])

useEffect(()=>{
  console.log(files)
},[
  files
])

useEffect(() => {
  if (!task && !stat && status?.length > 0) {
    setStat(status[0]._id);
  }
}, [stat, status, task]);

  // Обработчик сохранения комментария
  const handleSave = () => {
    const payload = {
      name,
      description,
      contractor,
      status: stat,
      executors,                                    // ← единственное поле
      finishDate: finishDate ? new Date(finishDate) * 1 : null,
    };

    if (task) {
      const comments = [...(task.comments || [])];
      if (comment !== '') comments.push({ date: Date.now(), author: id, text: comment });
      updateTask({ ...payload, comments }, task._id, files);
    } else {
      const comments = [];
      if (comment !== '') comments.push({ date: Date.now(), author: id, text: comment });
      addTask({ ...payload, creator, comments, createDate: Date.now() }, files);
    }
    onClose();
  };

  const handleDelete = () => {
    deleteTask(task._id);
    onClose();
  }
  // Обработчик закрытия окна
  const handleClose = () => {
    onClose();
  };

  const handleFileChange = (event) => {
      const selectedFiles = event.target.files; // This is a FileList
      // You can convert it to an array for easier manipulation:
      const filesArray = Array.from(selectedFiles);
      // Now you can process or store these files in your component's state
      setFiles(filesArray);
    };

  const handleDelFile = (link) => {
      debugger
      // let idx = task.files.findIndex((file)=>{return file.link === link})
      // if (idx !== -1){
        // task.files.splice(idx, 1);
        // updateTask(({files: task.files}), task._id)
        task.files.splice(link, 1)
        deleteFile(task._id, link)
      // }
  }

  const getUserName = (id) =>{
    let idx = users?.findIndex((user)=>{return user._id === id})
    if (idx !== undefined && idx >= 0 && users?.[idx]){
      return users[idx].name;
    }
    return '—';
  }

  // const currentExecutorName = getUserName(executor);

  return (
    <div className="modal-overlay">
      <div className="modal-window task-modal">
        <header className="task-modal__header">
          <h2 className="task-modal__title">{!task ? 'Новая запись в Задачи' : 'Редактирование записи в Задачи'}</h2>
          <button className="task-modal__close" onClick={handleClose}>×</button>
        </header>

        <section className="task-modal__body">
          <div className="task-modal__meta-title">Этапы выполнения задачи</div>
          <div className="task-modal__stages">
            {status?.map((statu) => (
              <button
                key={statu._id}
                type="button"
                className={`task-modal__stage ${stat === statu._id ? 'task-modal__stage--active' : ''}`}
                onClick={() => setStat(statu._id)}
              >
                {statu.name}
              </button>
            ))}
          </div>

          <div className="task-modal__section-title">Описание</div>

          <div className="task-modal__grid">
            <div className="task-modal__field">
              <label className="task-modal__label" htmlFor="name">
                Краткая формулировка задачи *
              </label>
              <input
                className={`task-modal__input ${!canEditCore ? 'task-modal__input--readonly' : ''}`}
                id="name"
                required
                value={name}
                onChange={event => setName(event.target.value)}
                disabled={!canEditCore}
                title={!canEditCore ? 'Редактировать может только создатель задачи' : undefined}
              />
              {!canEditCore && (
                <div className="task-modal__hint task-modal__hint--warn">
                  Название может менять только создатель задачи
                </div>
              )}
            </div>
            {/* <div className="task-modal__field">
              <label className="task-modal__label" htmlFor="name">Краткая формулировка задачи *</label>
              <input
                className="task-modal__input"
                id="name"
                required
                value={name}
                onChange={event => setName(event.target.value)}
              />
            </div> */}

            {/* <div className="task-modal__field">
              <label className="task-modal__label" htmlFor="executor">Исполнитель</label>
              <select
                id="executor"
                className="task-modal__input"
                value={executor}
                onChange={(e) => setExecutor(e.target.value)}
              >
                {users?.map(user => (
                  <option key={user._id} value={user._id}>{user.name}</option>
                ))}
              </select>
              <div className="task-modal__hint">{currentExecutorName}</div>
            </div> */}
            <div className="task-modal__field">
              <label className="task-modal__label">Исполнители</label>
              <ExecutorSelect
                users={users || []}
                value={executors}
                onChange={setExecutors}
                placeholder="Выберите исполнителей"
              />
            </div>

            <div className="task-modal__field">
              <label className="task-modal__label" htmlFor="finishDate">Крайний срок</label>
              <input
                type="datetime-local"
                className="task-modal__input"
                id="finishDate"
                value={finishDate}
                onChange={event => setFinishDate(event.target.value)}
              />
            </div>

            <div className="task-modal__field">
              <label className="task-modal__label" htmlFor="contractor">Контрагент</label>
              <select
                id="contractor"
                className="task-modal__input"
                value={contractor}
                onChange={(e) => setContractor(e.target.value)}
              >
                <option value="">Без контрагента</option>
                {contractors?.map(item => (
                  <option key={item._id} value={item._id}>{item.name}</option>
                ))}
              </select>
            </div>

            {task && (
              <div className="task-modal__field">
                <label className="task-modal__label" htmlFor="creator">Создатель</label>
                <div className="task-modal__readonly">{getUserName(creator)}</div>
                {/* <select className="task-modal__input" id="creator" value={creator} onChange={(e) => setCreator(e.target.value)}>
                  <option value={id}>{getUserName(id)}</option>
                </select> */}
              </div>
            )}

            {task && (
              <div className="task-modal__field">
                <label className="task-modal__label">Создана</label>
                <div className="task-modal__readonly">{new Date(task.createDate).toLocaleString()}</div>
              </div>
            )}

            <div className="task-modal__field task-modal__field--full">
              <label className="task-modal__label" htmlFor="description">Описание задачи</label>
              <textarea
                className={`task-modal__textarea ${!canEditCore ? 'task-modal__textarea--readonly' : ''}`}
                id="description"
                value={description}
                onChange={event => setDescription(event.target.value)}
                disabled={!canEditCore}
                title={!canEditCore ? 'Редактировать может только создатель задачи' : undefined}
              />
              {!canEditCore && (
                <div className="task-modal__hint task-modal__hint--warn">
                  Описание может менять только создатель задачи
                </div>
              )}
            </div>

            {/* <div className="task-modal__field task-modal__field--full">
              <label className="task-modal__label" htmlFor="description">Описание задачи</label>
              <textarea
                className="task-modal__textarea"
                id="description"
                value={description}
                onChange={event => setDescription(event.target.value)}
              />
            </div> */}

            <div className="task-modal__field task-modal__field--full">
              <label className="task-modal__label" htmlFor="files">Вложения</label>
              <input id="files" onChange={handleFileChange} type="file" multiple className="task-modal__input" />
              {task && task.files && (
                <div className="task-modal__files">
                  {task.files.map((file, idx) => (
                    <p key={idx}>
                      <b><a href={file.link}>{file.name}</a></b>
                      <button className="actionButton" onClick={() => handleDelFile(idx)}>x</button>
                    </p>
                  ))}
                </div>
              )}
            </div>

            <div className="task-modal__field task-modal__field--full">
              <label className="task-modal__label" htmlFor="comment">Новый комментарий</label>
              <textarea
                className="task-modal__textarea"
                id="comment"
                value={comment}
                onChange={event => setComment(event.target.value)}
              />
            </div>

            {task && task.comments && task.comments.length > 0 && (
              <div className="task-modal__field task-modal__field--full">
                <label className="task-modal__label">Комментарии</label>
                {task.comments.map(comm => (
                  <div key={comm.date} className="task-modal__comment">
                    <p>Создан: {new Date(comm.date).toLocaleString()}</p>
                    <p>Автор: {getUserName(comm.author)}</p>
                    <p>{comm.text}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <footer className="task-modal__footer">
          <button className="task-modal__btn task-modal__btn--ghost" onClick={handleClose}>Отмена</button>
          <button className="task-modal__btn task-modal__btn--secondary" onClick={handleSave}>Сохранить и перейти</button>
          <button className="task-modal__btn task-modal__btn--primary" onClick={handleSave}>Сохранить</button>
          {task && (roleType === "firstAdmin" || roleType === "admin") && (
            <button className="task-modal__btn task-modal__btn--danger" onClick={handleDelete}>Удалить</button>
          )}
        </footer>
      </div>
    </div>
  );
};

// Пропсы, обязательные для корректной работы
ModalWindow.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ModalWindow;